const getImages = state => {
  return state.property[0].images
}

const getAddress = state => {
  return state.property[0].address
}

const getSuburb = state => {
  return state.property[0].suburb
}

const getBed = state => {
  return state.property[0].bedrooms
}

const getBath = state => {
  return state.property[0].bathrooms
}

const getParking = state => {
  return state.property[0].parking
}

const getHeading = state => {
  return state.property[0].heading
}

const getDescription = state => {
  return state.property[0].description
}

const getAgents = state => {
  return state.property[0].agents
}

const getFloorplan = state => {
  return state.property[0].floorplan
}

const getSOI = state => {
  return state.property[0].soi
}

export default {
  getImages,
  getAddress,
  getSuburb,
  getBed,
  getBath,
  getParking,
  getHeading,
  getDescription,
  getAgents,
  getFloorplan,
  getSOI
}